import React from 'react';
import { YouTubeLiteEmbed } from '@utriper/core-ui';
import { Box, Grid2, IconButton } from '@mui/material';
import { DeleteOutline, VisibilityOutlined } from '@mui/icons-material';

const GalleryItem = ({ image, onRemove = () => {}, onOpen = () => {} }) => {
    const isVideo = image?.type === 3;

    const imageStyles = isVideo
        ? null
        : {
              backgroundImage: `url(${image?.src})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
          };

    const onStopPropagation = (event) => event?.stopPropagation();

    const stopPropagationProps = {
        onPointerDown: onStopPropagation,
        onMouseDown: onStopPropagation,
        onTouchStart: onStopPropagation,
    };

    return (
        <Grid2 container size={12} sx={{ position: 'relative', aspectRatio: '1/1', borderRadius: '4px', cursor: 'inherit', '& .MuiBox-root': { cursor: 'inherit' }, ...imageStyles }}>
            {isVideo && <YouTubeLiteEmbed videoId={image.src} title={' '} blockOnClick={true} playIconSize="1em" />}
            <Box sx={{ position: 'absolute', top: 4, left: 4, display: 'flex', gap: '4px', zIndex: 5 }}>
                <IconButton size="small" sx={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.6)' } }} onClick={onOpen} {...stopPropagationProps}>
                    <VisibilityOutlined sx={{ color: 'white', fontSize: '16px' }} />
                </IconButton>
                <IconButton size="small" sx={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.6)' } }} onClick={onRemove} {...stopPropagationProps}>
                    <DeleteOutline sx={{ color: 'white', fontSize: '16px' }} />
                </IconButton>
            </Box>
        </Grid2>
    );
};

export default GalleryItem;
